import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand text-brand-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-full bg-brand-accent flex items-center justify-center">
              <Leaf className="w-5 h-5 text-white" />
            </span>
            <span className="font-outfit font-bold text-lg">Network Survey</span>
          </div>
          <p className="font-figtree text-sm text-brand-cream/70 leading-relaxed">
            Energy-saving home improvements with no upfront costs — funded through grants and finance.
          </p>
        </div>

        <div>
          <h4 className="font-outfit font-semibold mb-4 text-sm uppercase tracking-wider text-brand-cream/60">Measures</h4>
          <ul className="space-y-2 font-figtree text-sm">
            <li><Link className="hover:text-brand-accent transition-colors" to="/measures">Insulation</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/measures">New Boilers</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/measures">Solar PV</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/measures">Heat Pumps</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-outfit font-semibold mb-4 text-sm uppercase tracking-wider text-brand-cream/60">Company</h4>
          <ul className="space-y-2 font-figtree text-sm">
            <li><Link className="hover:text-brand-accent transition-colors" to="/about">About Us</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/grants-finance">Grants & Finance</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/faq">FAQ</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/join-network">Join Our Network</Link></li>
            <li><Link className="hover:text-brand-accent transition-colors" to="/contact">Free Survey</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-outfit font-semibold mb-4 text-sm uppercase tracking-wider text-brand-cream/60">Get in touch</h4>
          <ul className="space-y-3 font-figtree text-sm">
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-brand-accent" /> +44 7879 320060</li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-brand-accent" /> info@networksurveyltd.uk</li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-brand-accent mt-0.5 shrink-0" /> 30 Runfold Avenue, Luton, LU3 2EH</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-cream/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-brand-cream/50 font-figtree">
          <p>© {new Date().getFullYear()} Network Survey Limited. All rights reserved.</p>
          <p>*Grant availability subject to eligibility. Finance subject to status.</p>
        </div>
      </div>
    </footer>
  );
}
